import Flickity from 'flickity';
import { gsap, Observer } from "../global/gsap";

const initFeaturedAlumni = (featuredAlumniEl) => {
    const media = gsap.matchMedia();
    const followImage = featuredAlumniEl.querySelector('.js-alumni-image');
    const hoverImage = followImage.querySelector('img');
    const alumniLinks = featuredAlumniEl.querySelectorAll('.js-alumni-person');

    media.add({
        isDesktop: '(min-width: 900px)'
    }, (context) => {
        const { isDesktop } = context.conditions;

        if (isDesktop) {
            gsap.set(followImage, { yPercent: -75, xPercent: -50, opacity: 0, scale: 0, pointerEvents: 'none' });

            const yTo = gsap.quickTo(followImage, 'y', { duration: 0.4, ease: 'power3' });
            const xTo = gsap.quickTo(followImage, 'x', { duration: 0.4, ease: 'power3' });

            Observer.create({
                target: featuredAlumniEl,
                type: "pointer",
                onMove: (self) => {
                    xTo(self.x);
                    yTo(self.y);
                }
            });

            alumniLinks.forEach(link => {
                link.addEventListener('mouseenter', (e) => {
                    const imageUrl = e.target.dataset.image;
                    const imageAlt = e.target.dataset.alt;

                    if (imageUrl && hoverImage) {
                        hoverImage.src = imageUrl;
                        hoverImage.alt = `${imageAlt} profile photo`;
                    }

                    gsap.to(followImage, {
                        opacity: 1,
                        scale: 1,
                        duration: 0.3,
                        overwrite: 'auto'
                    });
                });

                link.addEventListener('mouseleave', () => {
                    gsap.to(followImage, {
                        opacity: 0,
                        scale: 0,
                        duration: 0.3,
                        overwrite: 'auto'
                    });
                });
            });
        } else {
            gsap.set(followImage, { clearProps: 'all' });
        }
    });

    const carousel = featuredAlumniEl.querySelector('.js-alumni-carousel');

    const flickityOptions = {
        cellAlign: 'left',
        wrapAround: true,
        prevNextButtons: false,
        pageDots: false,
        draggable: true,
        setGallerySize: true,
        cellSelector: '.featured-alumni__slide'
    };

    const flkty = new Flickity(carousel, flickityOptions);
};

export { initFeaturedAlumni as default };
